import AuthFooter from './AuthFooter.json';

export default { ...AuthFooter };



// WEBPACK FOOTER //
// ./src/i18n/en/components/Auth/AuthFooter/index.js